import { render } from "./IconCheckboxSelected.vue?vue&type=template&id=0816b758"
import script from "./IconCheckboxSelected.vue?vue&type=script&lang=js"
export * from "./IconCheckboxSelected.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconCheckboxSelected.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0816b758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0816b758', __exports__)) {
    api.reload('0816b758', __exports__)
  }
  
  module.hot.accept("./IconCheckboxSelected.vue?vue&type=template&id=0816b758", () => {
    api.rerender('0816b758', render)
  })

}


export default __exports__